/** @flow */

import type { UserAccountsState } from "./types";
import { finishRequest } from "@store/utils";

export const setLoading = (state: UserAccountsState) => () => ({
  ...state,
  requestsInProgress: ++state.requestsInProgress,
});

export const setLoaded = (state: UserAccountsState) => () => ({
  ...state,
  ...finishRequest(state),
});

export const onGetUserAccountsSuccess = (state: UserAccountsState) => ({ payload }: Object) => ({
  ...state,
  requestsInProgress: state.requestsInProgress > 0 ? --state.requestsInProgress : 0,
  list: payload,
  error: null,
});

export const onGetUserAccountsError = (state: UserAccountsState) => ({ payload }: Object) => ({
  ...state,
  requestsInProgress: state.requestsInProgress > 0 ? --state.requestsInProgress : 0,
  error: payload,
});

export const onExportUserAccountsSuccess = (state: UserAccountsState) => () => ({
  ...state,
  requestsInProgress: state.requestsInProgress > 0 ? --state.requestsInProgress : 0,
  error: null,
});

export const onExportUserAccountsError = (state: UserAccountsState) => ({ payload }: Object) => ({
  ...state,
  requestsInProgress: state.requestsInProgress > 0 ? --state.requestsInProgress : 0,
  error: payload,
});

export const onGetUserTypesSuccess = (state: UserAccountsState) => ({ payload }: Object) => ({
  ...state,
  ...finishRequest(state),
  userTypes: payload.content,
  error: null,
});
